import { Heading } from '@dot/design-system';
import { useTranslation } from 'react-i18next';

import * as SC from './ProcessingStyles';

import * as GSC from '@/styles/GlobalStyles';

export type Props = {
  capturedImage: Blob | null;
};

export const Processing = ({ capturedImage }: Props) => {
  const { t } = useTranslation();

  return (
    <GSC.InfoContainer>
      {capturedImage && <GSC.BlobImage alt="captured image" blob={capturedImage} />}
      <GSC.DarkOverlay />
      <SC.Instruction>
        <Heading as="h3">{t('common.state.processing')}</Heading>
      </SC.Instruction>
    </GSC.InfoContainer>
  );
};
